import { TournFlags2 } from '@ps/web-poker-types';

import { formatIconImg, formatTags } from './formatters';
import { formatPppAttr } from './formatters/attributes';
import { Speed } from './formatters/game';
import defaultImage from './formatters/imageCash';
import imagePpp from './formatters/imagePpp';
import { TournGroupTypes } from './formatters/tournGroups';
import { RPGLink, RPGTypes } from './formatters/types';
import type { Options, PPPType, PokerGameTile } from './types';
import { getGameBuyInTier } from './utils';

function mapPPPType(
  {
    buyIn,
    lastEntry,
    staticData: {
      pppId,
      structure,
      isHiLo,
      handType,
      currency,
      isPlayMoney,
      maxPlayersPerTable,
      buyInTiers
    }
  }: PPPType,
  { language, hspFlagsMap, isPPPRevampNeymar }: Options
) {
  const tags = formatTags({
    speedDisplay: Speed.Hyper, // speed tag should be Hyper as per BRD, but server returns speedDisplay = 0
    game: handType,
    tournGroup: TournGroupTypes.TournGroup_None, // there is no tourn group for ProgressivePlus game, therefor tournGroup is not in a response
    structure,
    tournFlags2: TournFlags2.TOURNSCRIPT_FLAG2_KNOCKOUT.toString(10)
  }).filter((tag) => tag.title !== 'TIME'); // remove tags that are not in BRD https://confluence.pyrsoftware.ca/confluence/x/yQLqCw

  const gameTier = getGameBuyInTier(buyInTiers, buyIn);

  return {
    id: pppId,
    type: RPGTypes.PPP,
    link: RPGLink.PPP,
    imageUrl: imagePpp(language, hspFlagsMap, isPPPRevampNeymar),
    imageUrlV2: imagePpp(language, hspFlagsMap, isPPPRevampNeymar, true),
    fallbackImageUrl: defaultImage(handType, structure, buyIn, 0, isHiLo, 0),
    tags,
    lastEntry,
    attributes: formatPppAttr(
      {
        buyIn,
        rake: 0,
        currency,
        isPlayMoney,
        maxPlayersPerTable,
        winUpTo: gameTier?.potentialMaxKOWinToDisplay ?? 0
      },
      language
    ),
    iconUrl: formatIconImg(RPGTypes.SNG),
    clubId: 0,
    server: '',
    serverObj: ''
  };
}

const mapPPPTypes = (pppTypes: PPPType[], options: Options): PokerGameTile[] =>
  pppTypes.map((type) => mapPPPType(type, options));

export default mapPPPTypes;
